import { MarkupTheme } from '@/components/Markup/theme';
import { tw } from '@/utils/tw';

const Twitter = tw.theme({
  extend: MarkupTheme,
  base: '',
});

export default Twitter;
